import { ReactNode } from "react";

import { BackCta, Column, Icon, Link, Row, Text, IconWithBackground, MEDIA, TextVariant } from "@bridgesplit/ui";
import { COPY } from "app/constants";
import { doNothing } from "@bridgesplit/utils";
import { useMediaQuery } from "@mui/material";
import { ComingSoonBanner, ComingSoonTag } from "app/components/common";

export default function VaultDetailHeader({
    name,
    tokenImage,
    backTo,
    backCta,
    isFeatured,
    comingSoon,
    comingSoonBanner,
    rightActions,
    variant = "h3"
}: {
    name: string | undefined;
    tokenImage: ReactNode;
    backTo: string;
    backCta: string;
    isFeatured?: boolean;
    comingSoon?: boolean;
    comingSoonBanner?: string;
    rightActions?: ReactNode;
    variant?: TextVariant;
}) {
    return (
        <Column spacing={2}>
            <Link to={backTo}>
                <BackCta back={doNothing} backCta={backCta} />
            </Link>

            <Row spacing={1} spaceBetween>
                <Row spacing={1}>
                    {tokenImage}
                    <Text variant={variant}>{name}</Text>
                    {comingSoon ? <ComingSoonTag /> : isFeatured && <FeaturedVaultTag />}
                </Row>
                {rightActions && <Row spacing={1}>{rightActions}</Row>}
            </Row>

            {comingSoon && <ComingSoonBanner text={comingSoonBanner} />}
        </Column>
    );
}

function FeaturedVaultTag() {
    const isMobile = useMediaQuery(MEDIA.SM.below);
    return (
        <IconWithBackground
            tagColor="body"
            sx={{
                borderRadius: "20px",
                px: 2,
                py: 0.75,
                width: "auto",
                maxWidth: "none",
                minWidth: "auto",
                height: "auto",
                maxHeight: "none",
                minHeight: "auto",
                display: "flex",
                gap: 1
            }}
            variant="body2"
        >
            <Icon type="rocket" sx={{ fontSize: "20px" }} />
            {!isMobile && COPY.VAULT_TERM_FEATURED}
        </IconWithBackground>
    );
}
